import { projectRepository } from '@/storage/repositories/IndexedDbProjectRepository';
import { migrateProject } from '@/storage/migrations';
import { buildSeedProjects, useProjectLibrary, } from '@/features/project-library/projectLibraryStore';
import { MATTRESS_SCHEMA_VERSION } from '@/domain/mattress/types';
/**
 * Singleton de inicialização do store a partir da IndexedDB.
 *
 * Módulo-scoped (não component-scoped) — imune ao double-mount do
 * React Strict Mode e a múltiplas instâncias de PersistenceBridge.
 * Cada page load executa UMA hidratação, compartilhada entre consumidores.
 */
let initPromise = null;
export function initializeLibrary() {
    if (initPromise)
        return initPromise;
    initPromise = (async () => {
        try {
            const existing = await projectRepository.listAll();
            if (existing.length > 0) {
                const migrated = [];
                for (const raw of existing) {
                    try {
                        const p = migrateProject(raw);
                        migrated.push(p);
                        if (raw.schemaVersion !== MATTRESS_SCHEMA_VERSION) {
                            projectRepository.save(p).catch(() => { });
                        }
                    }
                    catch (err) {
                        console.warn('[persistence] falha ao migrar projeto', raw, err);
                    }
                }
                useProjectLibrary.getState().hydrateFromRepository(migrated);
                return;
            }
            // Primeira execução no dispositivo — seeda
            const seeds = buildSeedProjects();
            await Promise.all(seeds.map((p) => projectRepository.save(p)));
            useProjectLibrary.getState().hydrateFromRepository(seeds);
        }
        catch (err) {
            console.error('[persistence] hydration failed', err);
            useProjectLibrary.getState().setHydrationStatus('error');
        }
    })();
    return initPromise;
}
